<!--  -->
<template>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="提示" class="addClassify" :visible.sync="dialogVisible" width="540px">
        <div class="content">
            <p>分类名称</p>
            <el-input v-model="name" maxlength="10" show-word-limit></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">退出</el-button>
            <el-button type="primary" @click="uploadSxytopiccolumninfo">确认</el-button>
        </span>
    </el-dialog>
</template>

<script>
import {uploadSxytopiccolumninfo} from 'api/imageText'
import {mapActions} from 'vuex'
export default {
    data() {
        return {
            dialogVisible: false,
            name: '',
            isEdit: false,
            innerid: ''
        }
    },
    props: ['currenttop'],
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        open(name, innerid) {
            if (name) {
                this.name = name
                this.innerid = innerid
                this.isEdit = true
            } else {
                this.name = ''
                this.isEdit = false
            }
            this.dialogVisible = true
        },
        uploadSxytopiccolumninfo() {
            if (this.name) {
                this.setLoading(true)
                uploadSxytopiccolumninfo({
                    data: Object.assign({}, this.currenttop, {name: this.name, innerid: this.innerid}),
                    success: res => {
                        this.setLoading(false)
                        this.dialogVisible = false
                        if (!this.isEdit) {
                            this.$emit('addClassifySuccess', {name: this.name, innerid: res.data.innerid, columnindex: res.data.columnindex, newscount: 0})
                        } else {
                            this.$emit('editClassifySuccess', {name: this.name})
                        }
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$message.erro(res.$message)
                    }
                })
            } else {
                this.$message.error('请输入分类名称')
            }
        },
        ...mapActions([
            'setLoading'
        ])
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .addClassify {
        .el-dialog__body {
            padding: 30px 20px 20px;
            .content {
                display: flex;
                align-items: center;
                .el-input {
                    width: 396px;
                    height: 32px;
                    margin-left: 20px;
                }
            }
        }
        .el-dialog__footer {
            .el-button {
                margin-bottom: 0;
                &.el-button--primary {
                    margin-left: 20px;
                }
            }
        }
    }
</style>